import InvitationInterface from '@shared/types/invitation';
import PropertyInterface from '@shared/types/property';
import SkillInterface from '@shared/types/skill';
import {
  AGENCIES_COLLECTION,
  DRAFT_CONTRACTORS_COLLECTION,
  FILES_COLLECTION,
  INVITATIONS_COLLECTION,
  NOTIFICATION_COLLECTION,
  PACKAGES_COLLECTION,
  PAGE_VIEW_LOGS_COLLECTION,
  PARAMS_COLLECTION,
  PROPERTIES_COLLECTION,
  SKILLS_COLLECTION,
  SUBSCRIPTION_INVOICES_COLLECTION,
  SUBTASK_MESSAGES_COLLECTION,
  SUBTASKS_COLLECTION,
  TASK_MESSAGES_COLLECTION,
  TASKS_COLLECTION,
  USERS_COLLECTION,
} from '../constants/collections';
import {
  SubscriptionInvoice,
} from '../interfaces';
import { Agency } from '@shared/types/Agency';
import FileInterface from '../interfaces/file';
import { NotificationInterface } from '../interfaces/notification';
import { Package } from '../interfaces/Package';
import PageViewLog from '../interfaces/PageViewLog';

import TaskInterface from '@shared/types/task';

import { DraftContractorInterface } from '@shared/types/DraftContractorInterface';
import { NoteMessages } from '@shared/types/noteMessages';
import SubtaskInterface from '@shared/types/subtask';
import UserInterface from '@shared/types/user';
import { DataServiceClient } from './DataServiceClient';

export const packageDataService = new DataServiceClient<Package>(
  PACKAGES_COLLECTION,
);
export const taskDataService = new DataServiceClient<TaskInterface>(
  TASKS_COLLECTION,
);
export const subtaskDataService = new DataServiceClient<SubtaskInterface>(
  SUBTASKS_COLLECTION,
);
export const propertyDataService = new DataServiceClient<PropertyInterface>(
  PROPERTIES_COLLECTION,
);
export const userDataService = new DataServiceClient<UserInterface>(
  USERS_COLLECTION,
);
export const invitationDataService = new DataServiceClient<InvitationInterface>(
  INVITATIONS_COLLECTION,
);
export const notificationDataService =
  new DataServiceClient<NotificationInterface>(NOTIFICATION_COLLECTION);

export const skillDataService = new DataServiceClient<SkillInterface>(
  SKILLS_COLLECTION,
);

export const pageViewLogService = new DataServiceClient<PageViewLog>(
  PAGE_VIEW_LOGS_COLLECTION,
);

export const subscriptionInvoiceService =
  new DataServiceClient<SubscriptionInvoice>(SUBSCRIPTION_INVOICES_COLLECTION);

export const taskMessagesService = new DataServiceClient<NoteMessages>(
  TASK_MESSAGES_COLLECTION,
);

export const subtaskMessagesService = new DataServiceClient<NoteMessages>(
  SUBTASK_MESSAGES_COLLECTION,
);

export const fileService = new DataServiceClient<FileInterface>(
  FILES_COLLECTION,
);

export const draftContractorService =
  new DataServiceClient<DraftContractorInterface>(DRAFT_CONTRACTORS_COLLECTION);

export const agencyService = new DataServiceClient<Agency>(AGENCIES_COLLECTION);
export const paramsDataService = new DataServiceClient<Record<string, unknown>>(
  PARAMS_COLLECTION,
);